import { ProductDetail } from '@grpc-clients/external/mercury/v1/attraction/common/product-detail.pb';
import { Action } from '@ngrx/store';
import { ActivitiesForm } from '@shared/models/activities-form';
import { ActivitiesOrdering, ActivitiesPaging } from '@shared/models/activities.model';
import { ActivityFilter } from '@shared/models/filter.model';
import { ActivitiesMultipleChoiceFilter } from '@shared/store/models/activities-filter';
import { ActivityFilters } from '../reducers/activities.reducer';

export const GET_ACTIVITIES_SEARCH_RESULTS = '[Travel Activities Search] Get activities search results';
export const GET_ACTIVITIES_SEARCH_RESULTS_SUCCESS = '[Travel Activities Search] Get activities search results success';
export const GET_ACTIVITIES_SEARCH_RESULTS_FAILURE = '[Travel Activities Search] Get activities search results failure';
export const CLEAR_ACTIVITIES_SEARCH_RESULTS = '[Travel Activities Search] Clear activities search results';
export const SET_ACTIVITIES_SORT = '[Travel Activities Search] Set activities sort';
export const SET_ACTIVITIES_FILTER = '[Travel Activities Search] Set activities filter';
export const CLEAR_ACTIVITIES_FILTER = '[Travel Activities Search] Clear activities filter';
export const APPLY_ACTIVITIES_FILTER = '[Travel Activities Search] Apply activities filter';
export const ACTIVITIES_SEARCH_BY_NAME_FILTER_CHANGE =
  '[Travel Activities Search] Activities search by name filter change';
export const ACTIVITIES_PRICE_FILTER_CHANGE = '[Travel Activities Search] Activities price filter change';
export const ACTIVITIES_MULTIPLE_CHOICE_FILTER_CHANGE =
  '[Travel Activities Search] Activities multiple choice filter change';
export const ACTIVITIES_UPDATED = '[Travel Activities Search] Activities updated';
export const SET_ACTIVITIES_PAGING = '[Travel Activities Search] Set activities paging';
export const RESTORE_ACTIVITIES_STATE = '[Travel Activities Search] Restore activities state';
export const GET_ACTIVITIES_CATEGORIES = '[Travel Activities Search] Get activities categories';
export const GET_ACTIVITIES_CATEGORIES_SUCCESS = '[Travel Activities Search] Get activities categories success';
export const GET_ACTIVITIES_CATEGORIES_FAILURE = '[Travel Activities Search] Get activities categories failure';

export class GetActivitiesSearchResults implements Action {
  public readonly type = GET_ACTIVITIES_SEARCH_RESULTS;
  constructor(public form: ActivitiesForm) {}
}

export class GetActivitiesSearchResultsSuccess implements Action {
  public readonly type = GET_ACTIVITIES_SEARCH_RESULTS_SUCCESS;
  constructor(public payload: ProductDetail[]) {}
}

export class GetActivitiesSearchResultsFailure implements Action {
  public readonly type = GET_ACTIVITIES_SEARCH_RESULTS_FAILURE;
}
export class ClearActivitiesSearchResults implements Action {
  public readonly type = CLEAR_ACTIVITIES_SEARCH_RESULTS;
}

export class SetActivitiesSort implements Action {
  public readonly type = SET_ACTIVITIES_SORT;
  constructor(public payload: ActivitiesOrdering) {}
}

export class SetActivitiesFilter implements Action {
  public readonly type = SET_ACTIVITIES_FILTER;
  constructor(public filter: Partial<ActivityFilters> | null) {}
}

export class ClearActivitiesFilter implements Action {
  public readonly type = CLEAR_ACTIVITIES_FILTER;
  constructor(public name: string) {}
}

export class ApplyActivitiesFilter implements Action {
  public readonly type = APPLY_ACTIVITIES_FILTER;
}

export class ActivitiesSearchByNameFilterChange implements Action {
  public readonly type = ACTIVITIES_SEARCH_BY_NAME_FILTER_CHANGE;
  constructor(public searchQuery: string) {}
}

export class ActivitiesPriceFilterChange implements Action {
  public readonly type = ACTIVITIES_PRICE_FILTER_CHANGE;
  constructor(public price: [number, number]) {}
}

export class ActivitiesUpdated implements Action {
  public readonly type = ACTIVITIES_UPDATED;
  constructor(public activities: ProductDetail[]) {}
}

export class ActivitiesMultipleChoiceFilterChange implements Action {
  public readonly type = ACTIVITIES_MULTIPLE_CHOICE_FILTER_CHANGE;
  constructor(
    public name: keyof ActivitiesMultipleChoiceFilter,
    public value: string | number | boolean,
    public checked: boolean
  ) {}
}

export class SetActivitiesPaging implements Action {
  public readonly type = SET_ACTIVITIES_PAGING;
  constructor(public paging: ActivitiesPaging) {}
}

export class RestoreActivitiesState implements Action {
  public readonly type = RESTORE_ACTIVITIES_STATE;
}

export class GetActivitiesCategories implements Action {
  public readonly type = GET_ACTIVITIES_CATEGORIES;
  constructor(
    public locationId: string,
    public keepSelected: boolean
  ) {}
}

export class GetActivitiesCategoriesSuccess implements Action {
  public readonly type = GET_ACTIVITIES_CATEGORIES_SUCCESS;
  constructor(
    public categoryFilter: ActivityFilter<number>[],
    public keepSelected: boolean
  ) {}
}

export class GetActivitiesCategoriesFailure implements Action {
  public readonly type = GET_ACTIVITIES_CATEGORIES_FAILURE;
}

export type ActivitiesSearchActions =
  | GetActivitiesSearchResults
  | GetActivitiesSearchResultsSuccess
  | GetActivitiesSearchResultsFailure
  | ClearActivitiesSearchResults
  | SetActivitiesSort
  | SetActivitiesFilter
  | ClearActivitiesFilter
  | ApplyActivitiesFilter
  | ActivitiesSearchByNameFilterChange
  | ActivitiesPriceFilterChange
  | ActivitiesMultipleChoiceFilterChange
  | SetActivitiesPaging
  | RestoreActivitiesState
  | ActivitiesUpdated
  | GetActivitiesCategories
  | GetActivitiesCategoriesSuccess
  | GetActivitiesCategoriesFailure;
